import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react'

import Icon from '@/legacy-src/components/icons/Icon'

import { Button } from '@/src/domains/design-system/components/Button'

export interface TherapistFilterMenuTriggerUIProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: string
  children: ReactNode
}

export const TherapistFilterMenuTriggerUI = forwardRef<HTMLButtonElement, TherapistFilterMenuTriggerUIProps>(
  ({ icon, children, ...props }, ref) => (
    <Button
      size="small"
      variant={props['data-state'] === 'open' ? 'petrol' : 'secondary'}
      className="group w-full justify-between rounded-full"
      prefixIcon={<Icon icon={icon} className="text-primary" />}
      suffixIcon={
        <Icon
          icon="arrows-beak"
          className="text-primary transition-transform duration-300 ease-in-out group-data-[state=open]:rotate-180"
        />
      }
      ref={ref}
      {...props}
    >
      {children}
    </Button>
  ),
)

TherapistFilterMenuTriggerUI.displayName = 'TherapistFilterMenuTriggerUI'
